export interface TabOption<T extends string> {
  value: T;
  label: string;
}

interface TabsProps<T extends string> {
  value: T;
  onChange: (v: T) => void;
  options: readonly TabOption<T>[];
}

/** Underline tabs for switching page sections. Not for filters — use SegmentedControl. */
export function Tabs<T extends string>({ value, onChange, options }: TabsProps<T>) {
  return (
    <div className="ui-tabs" role="tablist">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
